
import { createSelector } from 'reselect';
import { RootState } from './store'; // Assuming you have a type RootState that defines your Redux store

// Define the type for the items in your dataArray
interface ChatRoom {
    unreadCount?: number; // unreadCount is optional
}

// Selector to get the array from Redux state
// const selectChatRooms = (state: RootState): ChatRoom[] => state.Chats.chatRoomLists as ChatRoom[];
const selectChatRooms2 = (state: RootState): any[] => state.ChatContacts2.chatContacts as any[];
const selectChatRoomsSup2 = (state: RootState) : any[] => state.ChatContacts2.chatContactsSup as any[];
// console.log('selectChatRooms:', selectChatRooms);
// console.log('selectChatRooms2:', selectChatRooms2);

// Memoized selector to compute total unread count
// export const selectTotalUnreadCount = createSelector(
//     [selectChatRooms],
//     (dataArray) => dataArray.reduce((total, item) => total + (item.unreadCount ?? 0), 0)
// );

// export const selectTotalUnreadCount = createSelector(
//     [selectChatRooms2],
//     (dataArray) => dataArray.reduce((total, item) => total + (item.unreadCount ?? 0), 0)
// );

// export const selectTotalUnreadCountSup = createSelector(
//     [selectChatRoomsSup2],
//     (dataArray) => dataArray.reduce((total, item) => total + (item.unreadCount ?? 0), 0)
// );

// 20261020: server total over ALL rooms (lists are paged, the loaded-room sum missed rooms not loaded yet);
// loaded-room sum only until the first server total arrives
const selectUnreadTotalCust = (state: RootState): number | null => state.ChatContacts2.unreadTotalCust;
const selectUnreadTotalSup = (state: RootState): number | null => state.ChatContacts2.unreadTotalSup;

export const selectTotalUnreadCount = createSelector(
    [selectChatRooms2, selectUnreadTotalCust],
    (dataArray, serverTotal) => serverTotal ?? dataArray.reduce((total, item) => total + (item.unreadCount ?? 0), 0)
);

export const selectTotalUnreadCountSup = createSelector(
    [selectChatRoomsSup2, selectUnreadTotalSup],
    (dataArray, serverTotal) => serverTotal ?? dataArray.reduce((total, item) => total + (item.unreadCount ?? 0), 0)
);



/* multiple array
import { createSelector } from 'reselect';
import { RootState } from './store';

// Define the type for the items in your lists
interface DataItem {
    unreadCount?: number; // unreadCount is optional
}

// Selector to get the chatRoomLists array from Redux state and cast it to DataItem[]
const selectChatRoomList = (state: RootState): DataItem[] => state.Chats.chatRoomLists as DataItem[];

// Selector to get the announcementLists array from Redux state and cast it to DataItem[]
const selectAnnouncementList = (state: RootState): DataItem[] => state.Announcements.announcementLists as DataItem[];

export const selectTotalUnreadCount = createSelector(
    [selectChatRoomList, selectAnnouncementList],
    (chatRoomList, announcementList) => {
        const chatRoomUnreadCount = chatRoomList.reduce((total, item) => total + (item.unreadCount ?? 0), 0);
        const announcementUnreadCount = announcementList.reduce((total, item) => total + (item.unreadCount ?? 0), 0);

        return chatRoomUnreadCount + announcementUnreadCount;
    }
);
*/
